import React from 'react'
import styles from './TotalPotAmount.module.css'
import { useTotalPotAmount } from '@/src/hooks/data/useGameTable'
import { parseDecimalValuesOfNumber } from '../../../Common/utils/GameUtils';
import gameAssets from '@themed-assets';

export default function TotalPotAmount({ tempTableId }) {
    const totalPotAmt = useTotalPotAmount(tempTableId);
    return totalPotAmt ? (
        <div className={styles.potAmountContainer}>
            <div className={styles.potAmountText}>
                <span className={styles.potAmountTextLabel}>Pot:</span>
                {
                    gameAssets.altChip ?
                        <img src={gameAssets.altChip} alt="addaAltChip" className={styles.potAmountChip} />
                        :
                        null
                }
                <span className={styles.potAmountValue}>{parseDecimalValuesOfNumber(totalPotAmt, 2, true, true)}</span>
            </div>
        </div>
    ) : null;
}
